import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, DialogContent, DialogFooter, Button} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {
  AlternativeProductData,
  useChangeProductContext,
} from '../Context/ChangeProduct/ChangeProductContext';
import {ChangeProductActions} from '../Context/ChangeProduct/ChangeProductActionTypes';
import {useSelector} from 'react-redux';
import {LayoutSelector} from '../../Selectors';
import useSettings from '../../Hooks/useSettings';

export type ChangeProductPreviewDialogProps = {
  open: boolean;
  selectedProduct: any;
  onChangeProduct: (ref: number) => void;
};

const ChangeProductPreviewImageDialog = ({
  open,
  onChangeProduct,
  selectedProduct,
  ...props
}: ChangeProductPreviewDialogProps) => {
  const ui = useUiState();
  const settings = useSettings();
  const changeProduct = useChangeProductContext();
  const productLayout = useSelector(LayoutSelector);
  const {t} = useTranslation();

  const serverURL = window.config.baseURL;
  const thumbnailPath = settings.state.urls.thumbnailPath;

  let highDPIPreviewImage;

  const getImagePath = (selectedProduct: AlternativeProductData) => {
    const previewImage = selectedProduct.previewImage;
    if (selectedProduct.highDPIPreviewImage) {
      highDPIPreviewImage = `${serverURL}/${thumbnailPath}/products/${productLayout.collectioncode}/${selectedProduct.thumbPath}/${selectedProduct.highDPIPreviewImage} 2x`;
    }
    return `${serverURL}/${thumbnailPath}/products/${productLayout.collectioncode}/${selectedProduct.thumbPath}/${previewImage}`;
  };

  // changeProduct preview image
  return (
    <Dialog
      open={open}
      focusFirstElement
      trapFocus={true}
      className={'min-w-fit min-h-fit'}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={selectedProduct.name}
      id={'change-product-preview-dialog'}
      onClose={() => {
        changeProduct.dispatch(
          ChangeProductActions.setChangeProductDialogPreviewImageDialogOpen(false)
        );
      }}
    >
      <DialogContent>
        <img src={getImagePath(selectedProduct)} srcSet={highDPIPreviewImage} alt="preview"></img>
      </DialogContent>
      <DialogFooter isSmallScreen={ui.state.isSmallScreen}>
        <Button
          label={t('*:str_ButtonClose')}
          buttonStyle={'negative'}
          onClick={() => {
            changeProduct.dispatch(
              ChangeProductActions.setChangeProductDialogPreviewImageDialogOpen(false)
            );
          }}
        />
        <Button
          label={t('*:str_ButtonChangeProduct')}
          buttonStyle={'primary'}
          onClick={() => {
            onChangeProduct(selectedProduct?.ref);
            changeProduct.dispatch(
              ChangeProductActions.setChangeProductDialogPreviewImageDialogOpen(false)
            );
          }}
        />
      </DialogFooter>
    </Dialog>
  );
};

export default ChangeProductPreviewImageDialog;
